module.exports = __webpack_public_path__ + "static/img/img-4-10.a496a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-10.png
// module id = y18l
// module chunks = 0